import { z } from 'zod'
import { baseSchema } from './base'

const baseCardSchema = baseSchema.extend({
  type: z.literal('card'),
  title: z.string().optional(),
  extra: z.any().array().optional(),
})

const cardBodySchema = z.lazy(() => z.any().array())

type Card = z.infer<typeof baseCardSchema> & {
  body?: z.infer<typeof cardBodySchema>
}

export const cardSchema: z.ZodType<Card> = baseCardSchema.extend({
  body: cardBodySchema.optional(),
})

export type CardSchema = z.infer<typeof cardSchema>
